<template>
	<div class="SummaryText">
		<template v-for="(content, i) in componentItem.content">
			<div :key="`${i}summary-text${index}`">
				<div v-if="i === 'background-image'">
					<BackgroundImage :backgroundImage="componentItem.content[i]" :forTemplate="componentItem.template" />
				</div>
				<div v-else-if="i === repeaterField">
					<Repeater
						:itemArray="componentItem.content"
						:itemField="i"
						:template="template"
					/>
				</div>
				<div v-else-if="typeof content !== 'object'" class="form-group">
					<label for="inp" class="inp">{{ i }}</label>
					<input type="text" class="form-control" :id="i" v-model="componentItem.content[i]" >
					<!-- <span class="label">Label</span>
					<span class="border"></span> -->
				</div>
			</div>
		</template>

		<BackgroundVideo :componentItemContent="componentItem.content" />
		<BackgroundAudio :componentItemContent="componentItem.content" />
	</div>
</template>

<script>
	import BackgroundImage from '../BackgroundImage';
	import BackgroundVideo from '../BackgroundVideo';
	import BackgroundAudio from '../BackgroundAudio';
	import Repeater from '../Repeater';

	export default {

		components: {
			BackgroundImage,
			BackgroundVideo,
			Repeater,
			BackgroundAudio
		},
		
		name: 'SummaryText',
		
		props: ['componentItem', 'index', 'componentTemplates'],

		data() {
			return {
				template: '',
				repeaterField: 'title'
			}
		},

		mounted() {
			this.template = this.getTemplate();
		},

		methods: {

			getTemplate() {
				for(let i = 0; i < this.componentTemplates.length; i++) {
					if(this.componentTemplates[i]['template'] === 'summary-text') {
						return JSON.parse(JSON.stringify(
							this.componentTemplates[i]['content'][this.repeaterField][0]
						));
					}
				}
			}

		}

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';
	
	.SummaryText{
	
	}

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>